module.exports = __webpack_public_path__ + "static/media/pool.e4b8c556.jpg";